var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zov-slider-dot",class:_vm.classList,style:(_vm.position)},[_c('div',{staticClass:"zov-slider-dot-label",domProps:{"innerHTML":_vm._s(_vm.label)}})])}
var staticRenderFns = []

export { render, staticRenderFns }